export const DEFAULT_PAGE_SIZE = 0

export const DEFAULT_CURRENT_PAGE = 0

export const MAX_ITEMS_CAROUSEL = 4
